/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MonthlySchoolDay.vue?vue&type=template&id=59ab1f5a&scoped=true&"
import script from "./MonthlySchoolDay.vue?vue&type=script&setup=true&lang=js&"
export * from "./MonthlySchoolDay.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MonthlySchoolDay.vue?vue&type=style&index=0&id=59ab1f5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ab1f5a",
  null
  
)

export default component.exports